import React, { useState } from 'react';
import {
  Menu as MuiMenu,
  MenuItem,
  Button,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Box
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Share as ShareIcon,
  Download as DownloadIcon,
  Archive as ArchiveIcon,
  Settings as SettingsIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { colorPrimary } from '../../Styles/Colors';

const StyledMenu = styled(MuiMenu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    minWidth: '200px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid #E0E0E0',
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '12px 16px',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: '#F3E5F5',
  },
  '& .MuiListItemIcon-root': {
    minWidth: '32px',
    color: '#666666',
  },
  '& .MuiListItemText-primary': {
    fontSize: '14px',
    color: '#424242',
  },
}));

const MenuButton = styled(Button)(({ variant: buttonVariant }) => ({
  borderRadius: '8px',
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 500,
  padding: '8px 16px',
  ...(buttonVariant === 'contained' && {
    backgroundColor: colorPrimary,
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor:colorPrimary,
    },
  }),
  ...(buttonVariant === 'outlined' && {
    border: `1px solid ${colorPrimary}`,
    color: colorPrimary,
    '&:hover': {
      backgroundColor: '#F3E5F5',
       border: `1px solid ${colorPrimary}`,
    },
  }),
  ...(buttonVariant === 'text' && {
    color: colorPrimary,
    '&:hover': {
      backgroundColor: '#F3E5F5',
    },
  }),
}));

const Menu = ({
  buttonText = "Menu Item",
  buttonVariant = "contained",
  menuItems = [
    { label: "Menu Item", icon: <EditIcon />, onClick: () => console.log('Edit clicked') },
    { label: "Menu Item", icon: <ShareIcon />, onClick: () => console.log('Share clicked') },
    { label: "Menu Item", icon: <DownloadIcon />, onClick: () => console.log('Download clicked') },
    { type: 'divider' },
    { label: "Menu Item", icon: <ArchiveIcon />, onClick: () => console.log('Archive clicked') },
    { label: "Menu Item", icon: <DeleteIcon />, onClick: () => console.log('Delete clicked') },
  ],
  variant = "basic", // basic, icon, custom
  disabled = false,
  style,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    }
    handleClose();
  };

  const renderButton = () => {
    if (variant === "icon") {
      return (
        <MenuButton
          variant="text"
          onClick={handleClick}
          disabled={disabled}
          style={style}
          {...props}
        >
          <MoreVertIcon />
        </MenuButton>
      );
    }

    return (
      <MenuButton
        variant={buttonVariant}
        onClick={handleClick}
        disabled={disabled}
        style={style}
        {...props}
      >
        {buttonText}
      </MenuButton>
    );
  };

  return (
    <Box>
      {renderButton()}
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'menu-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {menuItems.map((item, index) => {
          if (item.type === 'divider') {
            return <Divider key={index} sx={{ my: 1 }} />;
          }

          return (
            <StyledMenuItem
              key={index}
              onClick={() => handleMenuItemClick(item)}
            >
              {item.icon && (
                <ListItemIcon>
                  {item.icon}
                </ListItemIcon>
              )}
              <ListItemText primary={item.label} />
            </StyledMenuItem>
          );
        })}
      </StyledMenu>
    </Box>
  );
};

export default Menu;
